module.exports = __webpack_public_path__ + "img/purple-1-oval-open.351a3870.svg";